var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    main: _vm.main,
    side: _vm.side,
    top: !_vm.side,
    fixed: _vm.fixed,
    expanded: _vm.expandedSync
  }, _obj[_vm.color] = true, _obj )},[(_vm.burger)?_c('s-menu-item',{attrs:{"icon":"bars","burger":_vm.burger},on:{"click":_vm.toggleExpand}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }